:host {
  display: block;
}

gz-form-field {
  --margin-bottom-wrapper: var(--spacer);
}

.general-form,
.credentials-form {
  gz-form-field {
    --form-field-label-width: 272px;
  }
}

.actions {
  gz-form-field {
    --form-field-label-width: 254px;
  }
}

#archive-limit-size,
#archive-max-depth {
  --form-field-label-width: 254px;
}

#scan-file-types {
  --form-field-label-width: 272px;
}

.container {
  max-width: 886px;
  padding: calc(4 * var(--spacer)) 0 calc(6 * var(--spacer)) calc(5 * var(--spacer));

  gz-input#scan-target-input:focus-within {
    --dropdown-border-right: 1px solid var(--blue-layout-501-focus);
    --dropdown-border-left: 1px solid var(--blue-layout-501-focus);
    --dropdown-border-bottom: 1px solid var(--blue-layout-501-focus);
    --dropdown-border-top: 1px solid var(--blue-layout-501-focus);
  }
}

#scan-target-table {
  --column-max-width: unset;
}

gz-radio:not([checked]) + div.extra-scan-info > ul {
  display: none;
}

.scan-options-group {
  gz-radio {
    display: flex;
  }
}

.action-buttons {
  padding: calc(1.5 * var(--spacer)) calc(5 * var(--spacer));
  display: flex;
  justify-content: space-between;
  background-color: var(--white-layout-300-primary);
  border-top: 1px solid var(--chart-050-hover);
}

.target-header {
  display: flex;
  .target-field {
    flex-grow: 1;
  }
}

.text-black {
  color: var(--main-titles-inputs-600);
}

.form-subtitle {
  display: flex;
  align-items: center;
}

.accordion-title {
  color: var(--chart-300-icon-buttons);
}

gz-info-box {
  margin-left: calc(-1 * var(--spacer));
}

.link {
  font-size: var(--body-size);
}

.list {
  margin: 0;
  padding: 0 0 0 calc(5 * var(--spacer));
  li::marker {
    color: var(--body-text-arrows-400);
  }
}

.field-container {
  height: calc(4 * var(--spacer));
  margin-bottom: var(--spacer);
  display: flex;
  color: var(--chart-300-icon-buttons);

  gz-checkbox {
    margin-top: 6px;
  }

  &.radio-container {
    align-items: center;
    b {
      font-weight: 600;
      font-family: var(--font-family-secondary);
    }
    gz-radio {
      position: absolute;
      margin-bottom: 0;
      width: 100%;
    }
    gz-text {
      height: fit-content;
      margin-left: 24px;
    }
  }

  #scan-email-archives {
    margin-top: calc(2 * var(--spacer));
  }
}

.title-container {
  height: calc(4 * var(--spacer));
  margin-bottom: calc(2 * var(--spacer));
}

.inner-content {
  width: 560px;
}

.archive-max-depth {
  gz-dropdown {
    --form-field-input-width: 160px;
  }
}

.exclusion-form-input {
  display: flex;
}

gz-text {
  max-width: 870px;
  &.form-subtitle,
  &.actions-subtitle {
    color: var(--chart-300-icon-buttons);
  }
}

.disabled {
  gz-light-grid {
    opacity: 0.6;
  }

  gz-text,
  gz-title,
  ::part(radio-label),
  ::part(checkbox-label),
  ::part(form-field-label) {
    color: var(--grey-layout-202-disabled-icons);
  }

  gz-link {
    pointer-events: none;
    opacity: 0.3;
  }
}

gz-light-grid::part(light-grid) {
  --_lumo-grid-border-color: var(--chart-101-pressed-dividers);
  --_lumo-grid-secondary-border-color: var(--chart-101-pressed-dividers);
}

gz-light-grid {
  --grid-border-color: var(--chart-101-pressed-dividers);
  border-bottom: 1px solid var(--grid-border-color);
}

gz-light-grid[items='[]'] {
  --grid-border-color: transparent;
}

gz-light-grid.disabled#exclusions-grid {
  opacity: 0.6;
}

::part(actions-column) {
  width: 100%;
  display: flex;
  justify-content: center;
}

gz-data-table[disabled] {
  pointer-events: all !important;
}

#custom-extensions-chips-generator {
  width: 640px;
  --chip-list-width: 513px;
  --form-field-label-custom-width: 272px;
  &::part(chips-generator-form-field) {
    margin-left: 0;
  }

  &::part(chip-list) {
    height: auto;
  }

  &::part(search-input),
  &::part(footer) {
    display: none;
  }
}

#exclusion-path {
  width: 256px;
}

#cpu-usage-control-maximum-usage {
  margin-left: 27px !important;
}

.position-relative {
  position: relative;
}

gz-link {
  font-weight: 500;
}

.suggestions-link {
  margin-left: -1px;
  position: absolute;
  top: calc(4 * var(--spacer));
}

.radio-label {
  padding-left: 2px;
  color: var(--main-titles-inputs-600);
}

gz-checkbox {
  color: var(--main-titles-inputs-600);
}

.horizontal-layout-usage-control {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.module-icon-usage-control {
  margin-left: 10px;
}

.checkbox-container-usage-control {
  display: flex;
  align-items: center;
}
